// src/components/UserMessage.js

import React from 'react';

function UserMessage({ message, subtitleMode }) {
  const getSubtitleText = () => {
    // For the user, we always show the English transcript since Japanese isn't available
    if (subtitleMode === 'EN' || subtitleMode === 'JP') return message.english;
    return ''; // Return empty for 'OFF'
  };

  const text = getSubtitleText();
  if (!text) return null; // Don't render a bubble if subtitles are off

  return (
    <div className="user-speech">
      <p className="subtitle">{text}</p>
      {/* Student icon remains to differentiate speaker */}
      <p className="avatar-icon">🧒</p>
    </div>
  );
}

export default UserMessage;